import { useState, useEffect, useCallback } from "react";
import { validateBOUsersForm } from "../../validations/boUsersForm";
import { useToastPromise } from "../../components/toastPromise";
import { BOUsersController } from "../../controllers/boUsersController";
import { Textbox } from "../../components/textbox";
import { PopupDialog } from "../../components/popupDialog";
import Button from "@mui/material/Button";
import { RoleType } from "../../constants/roleType";
import { Dropdown } from "../../components/dropdown";

export const BOUsers = ({
  user,
  isOpen = false,
  handleClose,
  getAll,
  selectedData,
}) => {
  const toastPromise = useToastPromise();
  const initialInputs = {
    firstName: "",
    lastName: "",
    email: "",
    contactNum: "",
    password: "",
  };
  const [inputs, setInputs] = useState(initialInputs);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const handleTextChange = (event) => {
    saveInputs(event.target.name, event.target.value);
  };
  const onHandleChange = useCallback((value, name) => {
    saveInputs(name, value);
  }, []);
  const saveInputs = (name, value) => {
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const resetForm = () => {
    setInputs(initialInputs);
    setErrors({});
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateBOUsersForm(inputs);
    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      console.debug("Form submission failed due to validation errors.");
      return;
    }
    console.debug("Form validated successfully.");
    saveBOUsers();
  };
  const saveBOUsers = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        selectedData?.id
          ? BOUsersController.update({
              parameters: {
                ...inputs,
                id: selectedData.id,
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            })
          : BOUsersController.add({
              parameters: {
                ...inputs,
                createdBy: user.uid,
                createdDate: new Date().toLocaleString(),
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            });
      }),
      successMessage: (data) => {
        console.debug(data);
        return data;
      },
      errorMessage: (data) => data,
    }).finally(() => {
      setLoading(false);
      handleClose();
      resetForm();
      getAll();
    });
  };
  useEffect(() => {
    if (selectedData) {
      setInputs({
        firstName: selectedData.firstName,
        lastName: selectedData.lastName,
        email: selectedData.email,
        contactNum: selectedData.contactNum,
        password: selectedData.password,
        role: selectedData.role,
      });
    }
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  return (
    <PopupDialog
      name="boUsers"
      open={isOpen}
      onClose={() => {
        handleClose();
        resetForm();
      }}
      title={
        selectedData ? "Update BO Users Detail" : "Add New BO Users Detail"
      }
      neutralAction={handleClose}
      positiveAction={
        <Button onClick={handleSubmit} disabled={loading}>
          {loading
            ? selectedData
              ? "Updating"
              : "Adding"
            : selectedData
              ? "Update"
              : "Add"}
        </Button>
      }
      content={
        <form onSubmit={handleSubmit}>
          {selectedData ? (
            <Textbox
              type="text"
              name="id"
              value={selectedData.id}
              placeholder="ID"
              readOnly={true}
            />
          ) : null}
          <Textbox
            type="text"
            name="firstName"
            placeholder="First Name"
            value={inputs.firstName}
            onChange={handleTextChange}
            errorMsg={errors.firstName}
          />
          <Textbox
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={inputs.lastName}
            onChange={handleTextChange}
            errorMsg={errors.lastName}
          />
          {selectedData ? (
            <Textbox
              type="text"
              name="email"
              value={selectedData.email}
              placeholder="Email"
              readOnly={true}
            />
          ) : (
            <Textbox
              type="text"
              name="email"
              placeholder="Email"
              value={inputs.email}
              onChange={handleTextChange}
              errorMsg={errors.email}
            />
          )}
          <Textbox
            type="text"
            name="contactNum"
            placeholder="Contact Number"
            value={inputs.contactNum}
            onChange={handleTextChange}
            errorMsg={errors.contactNum}
          />
          <Textbox
            type="password"
            name="password"
            placeholder="Password"
            value={inputs.password}
            onChange={handleTextChange}
            errorMsg={errors.password}
          />
          <Dropdown
            name="role"
            title="Role"
            value={inputs.role}
            options={RoleType.RoleTypeList}
            onChangeFunc={onHandleChange}
            errorMsg={errors.role}
          />
        </form>
      }
    />
  );
};
